'use strict';

module.exports = ['AG', 'AI', 'LC', 'SR', 'SS', 'SX', 'HK'];
